import type { EffectDefinition, EffectContext } from './types'

interface PlasmaState {
  offsets: number[]
}

export const plasma: EffectDefinition = {
  id: 'plasma',
  name: 'Plasma',

  init(_ctx: EffectContext): PlasmaState {
    const offsets: number[] = []
    for (let i = 0; i < 6; i++) {
      offsets.push(Math.random() * Math.PI * 2)
    }
    return { offsets }
  },

  update(_state: unknown, _ctx: EffectContext) {
    // Plasma is purely time-based, no state updates needed
  },

  draw(state: unknown, ctx: EffectContext) {
    const s = state as PlasmaState
    const { ctx: c, width, height, time } = ctx
    const t = time / 1000

    const step = 8
    const imageData = c.createImageData(Math.ceil(width / step), Math.ceil(height / step))
    const data = imageData.data

    let idx = 0
    for (let py = 0; py < height; py += step) {
      for (let px = 0; px < width; px += step) {
        const nx = px / width
        const ny = py / height

        const v1 = Math.sin(nx * 6 + t * 0.7 + s.offsets[0]!)
        const v2 = Math.sin(ny * 8 + t * 0.5 + s.offsets[1]!)
        const v3 = Math.sin((nx + ny) * 5 + t * 0.6 + s.offsets[2]!)
        const v4 = Math.sin(Math.sqrt(((nx - 0.5) ** 2 + (ny - 0.5) ** 2)) * 10 + t * 0.8 + s.offsets[3]!)

        const v = (v1 + v2 + v3 + v4) / 4

        const r = Math.floor(Math.sin(v * Math.PI + s.offsets[4]!) * 40 + 60)
        const g = Math.floor(Math.sin(v * Math.PI + 2 + s.offsets[5]!) * 40 + 30)
        const b = Math.floor(Math.sin(v * Math.PI + 4) * 60 + 120)

        data[idx] = r
        data[idx + 1] = g
        data[idx + 2] = b
        data[idx + 3] = 25
        idx += 4
      }
    }

    // Draw small imageData then scale up
    const tempCanvas = new OffscreenCanvas(imageData.width, imageData.height)
    const tempCtx = tempCanvas.getContext('2d')!
    tempCtx.putImageData(imageData, 0, 0)

    c.imageSmoothingEnabled = true
    c.drawImage(tempCanvas, 0, 0, width, height)
  }
}
